import { render, staticRenderFns } from "./block.vue?vue&type=template&id=8f7f8040&scoped=true&"
import script from "./block.vue?vue&type=script&lang=js&"
export * from "./block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7f8040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f7f8040')) {
      api.createRecord('8f7f8040', component.options)
    } else {
      api.reload('8f7f8040', component.options)
    }
    module.hot.accept("./block.vue?vue&type=template&id=8f7f8040&scoped=true&", function () {
      api.rerender('8f7f8040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains_registration_requests/actions/block.vue"
export default component.exports